<script>

	import { pageOffset, universalScroll, toggleUniversalToPageScroll } from '../../js/model/stores';
	import TopNavigationSocial from "./TopNavigationSocial.svelte";
	import TopNavigationImplementers from "./TopNavigationImplementers.svelte";

	let lastPageYOffset;

	let requestRealPageOffset = () => {

		const newPageYOffset = $toggleUniversalToPageScroll + window.pageYOffset;

		console.log('scrollDiff', lastPageYOffset, newPageYOffset);

		if (lastPageYOffset === newPageYOffset) {
			pageOffset.set(Math.max(0, newPageYOffset));
			return;
		}

		lastPageYOffset = newPageYOffset;
		setTimeout(() => {
			requestAnimationFrame(requestRealPageOffset);
		}, 100);
	};

	let navigateTo = (click) => {

		lastPageYOffset = $toggleUniversalToPageScroll + window.pageYOffset;
		lastPageYOffset--;

        const href = click.target.getAttribute('href');

		document.querySelector(href).scrollIntoView({
			behavior: 'smooth'
		});

		requestRealPageOffset();
	};

</script>

<style>
	.links {
		position: relative;
		width: 70%;
		left: 15%;
		margin-bottom: 2em;
	}

	.links li {
		font-size: calc(var(--font-h1-size) * 1.5);
		font-weight: calc(var(--font-h1-weight) * 2);
		text-transform: uppercase;
		position: relative;
		height: calc(var(--font-h1-size) * 1.8);
	}

	.portrait .links li {
		height: calc(var(--font-h1-size) * 2);
	}

	.links li a {
		position: absolute;
		color: var(--color-black);
		text-decoration: none;
		vertical-align: middle;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(calc(-50% - 10px));
		/*height: calc(100% - 1.5vmin);*/
	}

	.portrait .links li a {
		transform: translateX(-50%) translateY(calc(-50% - 5px));
	}

	.links li::after {
		content: '';
		position: absolute;
		bottom: 0;
		width: 8em;
		left: 50%;
		height: 0.3em;
		background-color: var(--color-black);
		transform: translateX(-50%);
	}

	.links li:last-child::after {
		background-color: transparent;
	}
</style>
<ul class="links">
	<li><a href="#supporter" on:click|preventDefault={navigateTo}>Unterstützer</a></li>
	<li><a href="#participate" on:click|preventDefault={navigateTo}>Mitmachen</a></li>
	<li><a href="#partners" on:click|preventDefault={navigateTo}>Partnerlinks</a></li>
	<li><TopNavigationSocial/></li>
</ul>
